import {
  Actionsheet,
  ActionsheetBackdrop,
  ActionsheetContent,
  ActionsheetDragIndicator,
  ActionsheetDragIndicatorWrapper,
  ActionsheetIcon,
  ActionsheetItem,
  ActionsheetItemText,
} from "@/components/ui/actionsheet";
import {
  OrganizationQRDTO,
  ParticipantDTO,
  ParticipantDTORole,
  WalletDTO,
} from "@/generated/api/models";
import { InterfaceActionsheetProps } from "@gluestack-ui/actionsheet/lib/types";
import { DoorOpen, Edit, QrCode, Send, Trash } from "lucide-react-native";
import { useState } from "react";
import { useSession } from "@/utils/session.ctx";
import {
  RestaurantTeamModalDelete,
  RestaurantTeamModalEdit,
  RestaurantTeamModalQRCode,
} from "./restaurant.team.modal";
import {
  RestaurantQRCodesModalDelete,
  RestaurantQRCodesModalEdit,
  RestaurantQRCodesModalShowCode,
} from "./restaurant.qrcodes.modal";

export function RestaurantQRCodesActionSheet({
  organizationId,
  qr,
  onClose,
  ...rest
}: InterfaceActionsheetProps & {
  organizationId: string;
  qr: OrganizationQRDTO | undefined;
}) {
  const [editIsOpened, setEditIsOpened] = useState(false);
  const [deleteIsOpened, setDeleteIsOpened] = useState(false);
  const [qrIsOpened, setQrIsOpened] = useState(false);

  return (
    <>
      {qr && (
        <>
          <RestaurantQRCodesModalShowCode
            organizationId={organizationId}
            qr={qr}
            isOpen={qrIsOpened}
            onClose={() => setQrIsOpened(false)}
          />
          <RestaurantQRCodesModalEdit
            organizationId={organizationId}
            qr={qr}
            isOpen={editIsOpened}
            onClose={() => setEditIsOpened(false)}
          />
          <RestaurantQRCodesModalDelete
            organizationId={organizationId}
            qr={qr}
            isOpen={deleteIsOpened}
            onClose={() => setDeleteIsOpened(false)}
          />
        </>
      )}
      <Actionsheet closeOnOverlayClick onClose={onClose} {...rest}>
        <ActionsheetBackdrop />
        <ActionsheetContent>
          <ActionsheetDragIndicatorWrapper>
            <ActionsheetDragIndicator />
          </ActionsheetDragIndicatorWrapper>
          <ActionsheetItem
            onPress={() => {
              onClose?.();
              setQrIsOpened(true);
            }}
          >
            <ActionsheetIcon className="stroke-background-700" as={QrCode} size={16} />
            <ActionsheetItemText>Show QR-code</ActionsheetItemText>
          </ActionsheetItem>
          <ActionsheetItem
            onPress={() => {
              onClose?.();
              setEditIsOpened(true);
            }}
          >
            <ActionsheetIcon className="stroke-background-700" as={Edit} />
            <ActionsheetItemText>Edit QR-code</ActionsheetItemText>
          </ActionsheetItem>
          <ActionsheetItem
            onPress={() => {
              onClose?.();
              setDeleteIsOpened(true);
            }}
          >
            <ActionsheetIcon className="stroke-background-700" as={DoorOpen} />
            <ActionsheetItemText className="text-red-500">
              Delete
            </ActionsheetItemText>
          </ActionsheetItem>
        </ActionsheetContent>
      </Actionsheet>
    </>
  );
}
